<template>
  <div class="">
    <img
      class="bg-item"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4acc9c0c59ba207c44ee29a646f682b9.png"
      alt=""
    />
    <img
      class="bg-item"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d25870162f349d3c85c86d919d3ada2e.png"
      alt=""
    />
    <div class="fixed-btn" @click="bindReceive">领取我的运动视频课</div>
    <van-overlay :show="showLogin" @click="showLogin = false">
      <MyLogin
        v-if="showLogin"
        class="login-content"
        @close="bindLoginClose"
        @login="bindLogin"
      />
    </van-overlay>
  </div>
</template>
<script>
import MyLogin from '@/views/activity/camp-introduce/components/login'
export default {
  components: {
    MyLogin
  },
  data() {
    return {
      showLogin: false
    }
  },
  methods: {
    bindLoginClose() {
      this.showLogin = false
    },
    bindReceive() {
      this.showLogin = true
    },
    bindLogin(options) {
      let params = {
        phone: options.phone,
        identify_code: options.code,
        areaCode: '86',
        gender: '0',
        r_from: '4'
      }
      this.$http
        .getBaseApp('member/WaterClock/registerWaterUser', params)
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            this.$dialog
              .alert({
                title: '注册成功',
                message: '您已成功领取运动课程，请下载APP并登录观看',
                theme: 'round-button'
              })
              .then(() => {
                // on close
                location.href = 'https://member3.gymcity.com.cn/#/app-download'
              })
          } else {
            this.$dialog.alert({
              title: '提示',
              message: res.msg
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.bg-item {
  width: 100%;
}
.fixed-btn {
  position: fixed;
  left: 50%;
  bottom: 30px;
  transform: translate(-50%, 0%);
  width: 327px;
  height: 50px;
  background: #6236ff;
  box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.12);
  border-radius: 25px;
  line-height: 50px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
  text-shadow: 0px 6px 10px rgba(0, 0, 0, 0.12);
}
.login-content {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
}
</style>
